import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsParameters from "../../../src/SubTabsParameters";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';
import { SatelliteContext } from '../../context/SatelliteContext';
import { getSatelliteApiParam, satellitePayloadValue, displaySatellite } from '../../helpers/satellite';


import { saveAs } from 'file-saver';

  export default class ParametersProductsPackagingPallets extends Component{
    static contextType = SatelliteContext; 

    constructor(props) {
      super(props);
    
      this.state = {
        products: [],
        modalTitle: "",
        sapcode: "",
        productid: 0,
        productlabel: {
          productlabelid: 0,
          productlabelname: ""
        },
        itemtype: {
          itemtypeid: 0,
          itemtypename: ""
        },
        application: {
          applicationid: 0,
          applicationname: ""
        },
        migration: false,
        leadtime: "",
        satellite: "",
        initialLeadtime: "",
        initialSatellite: "",
        productdescription: "",
        supplier: {
          supplierid: 0,
          suppliername: ""
        },
        supplierreference: "",
        origincountryid: 0,
        productcost: "",
        country: {
          countryname: "",
          countryid: 0
        },
        currency: {
          currencyid: 0,
          devisename: ""
        },
        unitspercase: "",
        weicase: "",
        lencase: "",
        widcase: "",
        heicase: "",
        casesperpallet: "",
        weipallet: "",
        lenpallet: "",
        widpallet: "",
        heipallet: "",
        unitsperpallet: "",
        palletvalue: "",
        isactive: true,
        ProductIdFilter: "",
        SapcodeFilter: "",
        CountryNameFilter: "",
        CountryIdFilter: "",
        ProductDescriptionFilter: "",
        productsWithoutFilter: [],
        productlabelNames: [],
        itemtypeNames: [],
        applicationNames: [],
        supplierNames: [],
        countryNames: [], // Holds the list of country names
        currencyNames: [],
        sapCodes: [],
        productDescriptions: [],
        sapCodeExists: false,
        productDescriptionExists: false,
        loading: true,
        uniqueProductIdsPurchases:[],
        uniqueProductIdsKitsContentKits:[],
        uniqueProductIdsKitsContentProducts:[],
        uniqueProductIdsContainersContentProducts:[],

        uniqueProductIdsForecasts:[],
        uniqueProductIdsReturns:[],
        uniqueProductIdsInventories:[],
        uploadFile: null,
        uploadMessage: "",
        uploadErrors: [],
        uploadInputKey: 0,

      };

      this.downloadCSV = this.downloadCSV.bind(this);
      this.refreshList = this.refreshList.bind(this);
    }


    
  downloadCSV() {
    const { products } = this.state;
    const headers = [
      'productid',
      'sapcode',
      'labelname',
      'itemtype',
      'application',
      'leadtime',
      'satellite',
      'productdescription',
      'supplier',
      'supplierreference',
      'country',
      'productcost',
      'currency',
      'unitspercase',
      'weicase',
      'lencase',
      'widcase',
      'heicase',
      'casesperpallet',
      'weipallet',
      'lenpallet',
      'widpallet',
      'heipallet',
      'unitsperpallet',
      'palletvalue'
    ];
  
    const escapeCSVField = (field) => {
      if (field == null) {
        return 'N/A';
      }
      if (typeof field === 'string') {
        return `"${field.replace(/"/g, '""')}"`; // Escape double quotes by doubling them
      }
      return field;
    };
  
    const rows = products.map(dep => [
      escapeCSVField(dep.productid),
      escapeCSVField(dep.sapcode),
      escapeCSVField(dep.productlabel?.productlabelname),
      escapeCSVField(dep.itemtype?.itemtypename),
      escapeCSVField(dep.application?.applicationname),
      escapeCSVField(dep.leadtime),
      escapeCSVField(dep.satellite),
      escapeCSVField(dep.productdescription),
      escapeCSVField(dep.supplier?.suppliername),
      escapeCSVField(dep.supplierreference),
      escapeCSVField(dep.country?.countryname),
      escapeCSVField(dep.productcost),
      escapeCSVField(dep.currency.devisename),
      escapeCSVField(dep.unitspercase),
      escapeCSVField(dep.weicase),
      escapeCSVField(dep.lencase),
      escapeCSVField(dep.widcase),
      escapeCSVField(dep.heicase),
      escapeCSVField(dep.casesperpallet),
      escapeCSVField(dep.weipallet),
      escapeCSVField(dep.lenpallet),
      escapeCSVField(dep.widpallet),
      escapeCSVField(dep.heipallet),
      escapeCSVField(dep.unitsperpallet),
      escapeCSVField(dep.palletvalue)

    ]);
  
    let csvContent = '';
    csvContent += headers.join(';') + '\r\n';
    rows.forEach(rowArray => {
      const row = rowArray.join(';');
      csvContent += row + '\r\n';
    });
  
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // Format today's date as YYYY-MM-DD
  
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], {
      type: 'text/csv;charset=utf-8'
  });
    saveAs(blob, `products_${formattedDate}.csv`);
  }
  
    

  FilterFn(){
    var ProductIdFilter=this.state.ProductIdFilter;
    var SapcodeFilter = this.state.SapcodeFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;

    var filteredData=this.state.productsWithoutFilter.filter(
        function(el){
            return el.productid.toString().toLowerCase().includes(
                ProductIdFilter.toString().trim().toLowerCase()
            )&&
            el.sapcode.toString().toLowerCase().includes(
                SapcodeFilter.toString().trim().toLowerCase()
            )&&
            el.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({products:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.productsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({products:sortedData});

}

changeProductIdFilter = (e)=>{
  this.state.ProductIdFilter=e.target.value;
  this.FilterFn();
}
changeSapcodeFilter = (e)=>{
  this.state.SapcodeFilter=e.target.value;
  this.FilterFn();
}

changeProductDescriptionFilter = (e)=>{
  this.state.ProductDescriptionFilter=e.target.value;
  this.FilterFn();
}


refreshList = () => {
  const params = {};
  const sat = getSatelliteApiParam(this.context?.satellite);
  if (sat) params.satellite = sat;
  axiosService.get('/defaultproducts/', { params })
    .then((response) => {
      const data = response.data?.results ?? response.data;
      this.setState({ products: data, productsWithoutFilter: data, loading: false });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
      this.setState({ loading: false });
    });
};

fetchProductlabelNames() {
  axiosService.get('/productlabels/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const productlabelNames = data.map(item => item.productlabelname);
      this.setState({ productlabelNames: productlabelNames });
    })
    .catch(error => {
      console.error("Error fetching productlabel names:", error);
    });
}


fetchItemtypeNames() {
  axiosService.get('/itemtypes/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const itemtypeNames = data.map(item => item.itemtypename);
      this.setState({ itemtypeNames: itemtypeNames });
    })
    .catch(error => {
      console.error("Error fetching itemtype names:", error);
    });
}

fetchApplicationNames() {
  axiosService.get('/applications/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const applicationNames = data.map(item => item.applicationname);
      this.setState({ applicationNames: applicationNames });
    })
    .catch(error => {
      console.error("Error fetching application names:", error);
    });
}

fetchSupplierNames() {
  axiosService.get('/suppliers/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const supplierNames = filteredData.map(item => item.suppliername);
      this.setState({ supplierNames: supplierNames });
    })
    .catch(error => {
      console.error("Error fetching supplier names:", error);
    });
}

fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames =  filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}



fetchCurrencyNames() {
  axiosService.get('/currencies/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const currencyNames = data.map(item => item.devisename);
      this.setState({ currencyNames: currencyNames });
    })
    .catch(error => {
      console.error("Error fetching currency names:", error);
    });
}


fetchSapCodes() {
  axiosService.get('/defaultproducts/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const sapCodes = data.map(item => item.sapcode);
      this.setState({ sapCodes: sapCodes });
    })
    .catch(error => {
      console.error("Error fetching SAP codes:", error);
    });
}

fetchProductDescriptions() {
  axiosService.get('/defaultproducts/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const productDescriptions = data.map(item => item.productdescription);
      this.setState({ productDescriptions : productDescriptions });
    })
    .catch(error => {
      console.error("Error fetching productDescriptions:", error);
    });
}

checkSapCodeExists = (event) => {
  const enteredSapCode = event.target.value.toLowerCase(); // Convert to lowercase
  const { sapCodes } = this.state;
  const sapCodeExists = sapCodes.some((sapCode) => sapCode.toLowerCase() === enteredSapCode);
  this.setState({ sapCodeExists });
};


checkProductDescriptionExists = (event) => {
  const enteredProductDescription = event.target.value.toLowerCase(); // Convert to lowercase
  const { productDescriptions } = this.state;
  const productDescriptionExists = productDescriptions.some(
    (description) => description.toLowerCase() === enteredProductDescription
  );
  this.setState({ productDescriptionExists });
};

fetchProductIdsPurchases() {
  axiosService.get('/purchasescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter((item) => item.purchasetypeid === 2);
      const uniqueProductIdsPurchases = [...new Set(filteredData.map((item) => item.itempurchasedid_id))];

      this.setState({ uniqueProductIdsPurchases: uniqueProductIdsPurchases });
    })
    .catch((error) => {
      console.error('Error fetching Products data:', error);
    });
}

fetchProductIdsKitsContentKits() {
  axiosService.get('/kitscontentcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsKitsContentKits = [...new Set(data.map((item) => item.kitid))];
      this.setState({ uniqueProductIdsKitsContentKits: uniqueProductIdsKitsContentKits });
    })
    .catch((error) => {
      console.error('Error fetching Kits Content data:', error);
    });
}

fetchProductIdsKitsContentProducts() {
  axiosService.get('/kitscontentcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsKitsContentProducts = [...new Set(data.map((item) => item.productid))];
      this.setState({ uniqueProductIdsKitsContentProducts: uniqueProductIdsKitsContentProducts });
    })
    .catch((error) => {
      console.error('Error fetching Kits Content data:', error);
    });
}

fetchProductIdsContainersContentProducts() {
  axiosService.get('/containerscontentcreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsContainersContentProducts = [...new Set(data.map((item) => item.productid))];
      this.setState({ uniqueProductIdsContainersContentProducts: uniqueProductIdsContainersContentProducts });
    })
    .catch((error) => {
      console.error('Error fetching Containers Content data:', error);
    });
}


fetchProductIdsForecasts() {
  axiosService.get('/forecastscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsForecasts = [...new Set(data.map((item) => item.productid))];
      this.setState({ uniqueProductIdsForecasts: uniqueProductIdsForecasts });
    })
    .catch((error) => {
      console.error('Error fetching Kits Content data:', error);
    });
}

fetchProductIdsReturns() {
  axiosService.get('/returnscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsReturns = [...new Set(data.map((item) => item.productid))];
      this.setState({ uniqueProductIdsReturns: uniqueProductIdsReturns });
    })
    .catch((error) => {
      console.error('Error fetching Kits Content data:', error);
    });
}



fetchProductIdsInventories() {
  axiosService.get('/inventoriescreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueProductIdsInventories = [...new Set(data.map((item) => item.productid))];
      this.setState({ uniqueProductIdsInventories: uniqueProductIdsInventories });
    })
    .catch((error) => {
      console.error('Error fetching Kits Content data:', error);
    });
}


componentDidUpdate(_prevProps, _prevState) {
  const sat = this.context?.satellite;
  if (this._lastProductsSatellite !== sat) {
    this._lastProductsSatellite = sat;
    this.setState({ loading: true });
    this.refreshList();
  }
}

componentDidMount(){
  this._lastProductsSatellite = this.context?.satellite;
  this.refreshList();
  this.fetchProductlabelNames();
  this.fetchItemtypeNames();
  this.fetchApplicationNames();
  this.fetchSupplierNames();
  this.fetchCountryNames();
  this.fetchCurrencyNames();
  this.fetchSapCodes();
  this.fetchProductDescriptions();
  this.fetchProductIdsPurchases();
  this.fetchProductIdsKitsContentKits();
  this.fetchProductIdsKitsContentProducts();
  this.fetchProductIdsContainersContentProducts();
  this.fetchProductIdsForecasts();
  this.fetchProductIdsReturns();
  this.fetchProductIdsInventories();
}

handleUploadFileChange = (event) => {
  this.setState({
    uploadFile: event.target.files[0] || null,
    uploadMessage: "",
    uploadErrors: []
  });
};

uploadProducts = () => {
  const { uploadFile } = this.state;

  if (!uploadFile) {
    alert("Please select a CSV file to upload.");
    return;
  }

  const formData = new FormData();
  formData.append("file", uploadFile);

  axiosService
    .post("/defaultproductsupload/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      const data = response.data || {};
      const message = data.message || "Upload completed.";
      const errors = Array.isArray(data.errors) ? data.errors : [];

      this.setState((prevState) => ({
        uploadMessage: message,
        uploadErrors: errors,
        uploadFile: null,
        uploadInputKey: prevState.uploadInputKey + 1,
      }));

      this.refreshList();
      this.fetchSapCodes();
      this.fetchProductDescriptions();

      if (errors.length > 0) {
        alert(message + "\n\n" + errors.length + " row(s) had errors. See details below.");
      } else {
        alert("Success: " + message);
      }
    })
    .catch((error) => {
      let message = "Upload failed.";

      if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        if (data && data.error) {
          message = `Error ${status}: ${data.error}`;
        } else if (typeof data === "string") {
          message = `Error ${status}: ${data}`;
        } else {
          message = `Error ${status}: ${message}`;
        }
      } else if (error.message) {
        message = error.message;
      }

      this.setState((prevState) => ({
        uploadMessage: message,
        uploadErrors: [],
        uploadInputKey: prevState.uploadInputKey + 1,
      }));
      alert(message);
    });
};

changeSapCode =(e)=>{
  this.setState({sapcode:e.target.value});
}

changeProductId =(e)=>{
  this.setState({productid:e.target.value});
}
changeProductLabelID =(e)=>{
  this.setState({productlabelid:e.target.value});
}

changeItemTypeId =(e)=>{
  this.setState({itemtypeid:e.target.value});
}

changeApplicationId =(e)=>{
  this.setState({applicationid:e.target.value});
}

changeMigration = (event) => {
  const isChecked = event.target.checked;
  this.setState({ migration: isChecked });
};

changeLeadtime =(e)=>{
  this.setState({leadtime:e.target.value});
}

changeSatellite =(e)=>{
  this.setState({satellite:e.target.value});
}

changeProductDescription =(e)=>{
  this.setState({productdescription:e.target.value});
}

changeSupplierReference =(e)=>{
  this.setState({supplierreference:e.target.value});
}

changeProductCost =(e)=>{
  this.setState({productcost:e.target.value});
}

changeCurrencyId =(e)=>{
  this.setState({currencyid:e.target.value});
}

changeUnitsPerCase =(e)=>{
  this.setState({unitspercase:e.target.value});
}

changeWeiCase =(e)=>{
  this.setState({weicase:e.target.value});
}

changeLenCase =(e)=>{
  this.setState({lencase:e.target.value});
}

changeWidCase =(e)=>{
  this.setState({widcase:e.target.value});
}

changeHeiCase =(e)=>{
  this.setState({heicase:e.target.value});
}

changeCasesPerPallet =(e)=>{
  this.setState({casesperpallet:e.target.value});
}

changeWeiPallet =(e)=>{
  this.setState({weipallet:e.target.value});
}

changeLenPallet =(e)=>{
  this.setState({lenpallet:e.target.value});
}

changeWidPallet =(e)=>{
  this.setState({widpallet:e.target.value});
}

changeHeiPallet =(e)=>{
  this.setState({heipallet:e.target.value});
}

changeUnitsPerPallet =(e)=>{
  this.setState({unitsperpallet:e.target.value});
}

changePalletValue =(e)=>{
  this.setState({palletvalue:e.target.value});
}


changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};


changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}

changeCountryId =(e)=>{
  this.setState({countryid:e.target.value});
}

resetSelect = () => {
  setTimeout(() => {
    this.setState({ selectedProductlabel: this.state.productlabelname });
    this.setState({ selectedItemtype: this.state.itemtypename });
    this.setState({ selectedApplication: this.state.applicationname });
    this.setState({ selectedCurrency: this.state.devisename });
    this.setState({ selectedSupplier: this.state.suppliername });
    this.setState({ selectedCountry: this.state.countryname });

  }, 0);
};

addClick(){
  this.resetSelect();
  this.setState({
      modalTitle:"Add Product" ,
      productid:0,
      sapcode: "",
      productlabelname:"",
      productlabelid:0,
      itemtypename:"",
      itemtypeid:0,
      applicationname:"",
      applicationid:0,
      migration:false,
      leadtime:"",
      satellite:"",
      initialLeadtime:"",
      initialSatellite:"",
      productdescription:"",
      suppliername:"",
      supplierid:0,
      supplierreference:"",
      countryname:"",
      countryid:0,
      productcost:"",
      devisename:"",
      currencyid:0,
      unitspercase:"",
      weicase:"",
      lencase:"",
      widcase:"",
      heicase:"",
      casesperpallet:"",
      weipallet:"",
      lenpallet:"",
      widpallet:"",
      heipallet:"",
      isactive:true,
      sapCodeExists: false,
      productDescriptionExists: false,
      
  });
}

editClick(dep){
  this.resetSelect();
  this.setState({
      modalTitle:"Edit Product",
      productid:dep.productid,
      sapcode:dep.sapcode,
      productlabelname:dep.productlabel.productlabelname,
      itemtypename:dep.itemtype.itemtypename,
      applicationname:dep.application.applicationname,
      migration:dep.migration,
      leadtime: dep.leadtime ?? "",
      satellite: dep.satellite ?? "",
      productdescription:dep.productdescription,
      suppliername:dep.supplier.suppliername,
      supplierreference:dep.supplierreference,
      countryname:dep.country.countryname,
      productcost:dep.productcost,
      devisename:dep.currency.devisename,
      unitspercase:dep.unitspercase,
      weicase:dep.weicase,
      lencase:dep.lencase,
      widcase:dep.widcase,
      heicase:dep.heicase,
      casesperpallet:dep.casesperpallet,
      weipallet:dep.weipallet,
      lenpallet:dep.lenpallet,
      widpallet:dep.widpallet,
      heipallet:dep.heipallet,
      isactive:dep.isactive,
      initialSapcode:dep.sapcode,
      initialProductlabelname:dep.productlabel.productlabelname,
      initialItemtypename:dep.itemtype.itemtypename,
      initialApplicationname:dep.application.applicationname,
      initialMigration:dep.migration,
      initialLeadtime: dep.leadtime ?? "",
      initialSatellite: dep.satellite ?? "",
      initialProductdescription:dep.productdescription,
      initialSuppliername:dep.supplier.suppliername,
      initialSupplierreference:dep.supplierreference,
      initialCountryname:dep.country.countryname,
      initialProductcost:dep.productcost,
      initialDevisename:dep.currency.devisename,
      initialUnitspercase:dep.unitspercase,
      initialWeicase:dep.weicase,
      initialLencase:dep.lencase,
      initialWidcase:dep.widcase,
      initialHeicase:dep.heicase,
      initialCasesperpallet:dep.casesperpallet,
      initialWeipallet:dep.weipallet,
      initialLenpallet:dep.lenpallet,
      initialWidpallet:dep.widpallet,
      initialHeipallet:dep.heipallet,
      initialIsactive:dep.isactive,
      sapCodeExists: false,
      productDescriptionExists: false,
      
  });
}


createClick() {
  const { sapcode, 
    productlabelname, 
    itemtypename, 
    applicationname, 
    migration,
    leadtime,
    satellite,
    productdescription,
    suppliername,
    supplierreference,
    countryname,
    productcost,
    devisename,
    unitspercase,
    weicase,
    lencase,
    widcase,
    heicase,
    casesperpallet,
    weipallet,
    lenpallet,
    widpallet,
    heipallet,
    isactive, 
    sapCodes,
  productDescriptions } = this.state;


    if (!sapcode) {
      alert('SAP code is required');
      return;
    }
    if (sapCodes.some(code => code.toLowerCase() === sapcode.toLowerCase())) {
      alert('SAP code already exists. Please provide a unique SAP code.');
      return;
    }
    
  
    if (!productlabelname) {
      alert('productlabel is required');
      return;
    }
  
    if (!itemtypename) {
      alert('itemtype is required');
      return;
    }
  
    if (!applicationname) {
      alert('application is required');
      return;
    }
  
    if (!productdescription) {
      alert('productdescription is required');
      return;
    }

    if (productDescriptions.some(desc => desc.toLowerCase() === productdescription.toLowerCase())) {
      alert('Product Description already exists. Please provide a unique Product Description.');
      return;
    }
    
  
    if (!productcost) {
      alert('Cost is required');
      return;
    }
  
    if (!devisename) {
      alert('Devise is required');
      return;
    }



  axiosService.post('/defaultproductscreate/', {
    sapcode:sapcode,
    productlabelname:productlabelname,
    itemtypename:itemtypename, 
    applicationname:applicationname, 
    migration:migration,
    leadtime: leadtime === "" ? null : Number(leadtime),
    satellite: satellitePayloadValue(satellite),
    productdescription:productdescription,
    suppliername:suppliername,
    supplierreference:supplierreference,
    countryname:countryname,
    productcost:productcost,
    devisename:devisename,
    unitspercase:unitspercase,
    weicase:weicase,
    lencase:lencase,
    widcase:widcase,
    heicase:heicase,
    casesperpallet:casesperpallet,
    weipallet:weipallet,
    lenpallet:lenpallet,
    widpallet:widpallet,
    heipallet:heipallet,
    isactive:isactive
  })
    .then(result => {
      alert('Product created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {

  const {
    sapcode, 
    productlabelname, 
    itemtypename, 
    applicationname, 
    migration,
    leadtime,
    satellite,
    productdescription,
    suppliername,
    supplierreference,
    countryname,
    productcost,
    devisename,
    unitspercase,
    weicase,
    lencase,
    widcase,
    heicase,
    casesperpallet,
    weipallet,
    lenpallet,
    widpallet,
    heipallet,
    isactive,
    initialSapcode,
    initialProductlabelname,
    initialItemtypename,
    initialApplicationname,
    initialMigration,
    initialLeadtime,
    initialSatellite,
    initialProductdescription,
    initialSuppliername,
    initialSupplierreference,
    initialCountryname,
    initialProductcost,
    initialDevisename,
    initialUnitspercase,
    initialWeicase,
    initialLencase,
    initialWidcase,
    initialHeicase,
    initialCasesperpallet,
    initialWeipallet,
    initialLenpallet,
    initialWidpallet,
    initialHeipallet,
    initialIsactive,
    sapCodes,
    productDescriptions
   } = this.state;

   // Check if any changes are detected
   if (
    sapcode === initialSapcode 
    &&
    productlabelname === initialProductlabelname 
    &&
    itemtypename === initialItemtypename
    &&
    applicationname === initialApplicationname
    &&
    migration === initialMigration
    &&
    leadtime === initialLeadtime
    &&
    satellite === initialSatellite
    &&
    productdescription === initialProductdescription
    &&
    suppliername === initialSuppliername
    &&
    supplierreference === initialSupplierreference
    &&
    countryname === initialCountryname
    &&
    productcost === initialProductcost
    &&
    devisename === initialDevisename
    &&
    unitspercase === initialUnitspercase
    &&
    weicase === initialWeicase
    &&
    lencase === initialLencase
    &&
    widcase === initialWidcase
    &&
    heicase === initialHeicase
    &&
    casesperpallet === initialCasesperpallet
    &&
    weipallet === initialWeipallet
    &&
    lenpallet === initialLenpallet
    &&
    widpallet === initialWidpallet
    &&
    heipallet === initialHeipallet
    &&
    isactive === initialIsactive
  ) {
    alert('No changes detected');
    return;
  }

  if (!sapcode) {
    alert('SAP Code is required');
    return;
  }

  if (sapCodes.some(name => name.toLowerCase() === sapcode.toLowerCase() && sapcode !== initialSapcode)) {
    alert('SAP Code already exists. Please provide a unique SAP Code.');
    return;
  }

  if (!productlabelname) {
    alert('productlabel is required');
    return;
  }

  if (!itemtypename) {
    alert('itemtype is required');
    return;
  }

  if (!applicationname) {
    alert('application is required');
    return;
  }

  if (!productdescription) {
    alert('productdescription is required');
    return;
  }

  if (productDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase() && productdescription !== initialProductdescription)) {
    alert('Product Description already exists. Please provide a unique Product Description.');
    return;
  }

  if (!productcost) {
    alert('Cost is required');
    return;
  }

  if (!devisename) {
    alert('Devise is required');
    return;
  }




  axiosService.patch('/defaultproductsupdate/' + id + '/', {
    productid: this.state.productid,
    sapcode:this.state.sapcode,
    productlabelname: this.state.productlabelname,
    itemtypename: this.state.itemtypename,
    applicationname: this.state.applicationname,
    migration: this.state.migration,
    leadtime: this.state.leadtime === "" ? null : Number(this.state.leadtime),
    satellite: satellitePayloadValue(this.state.satellite),
    productdescription: this.state.productdescription,
    suppliername: this.state.suppliername,
    supplierreference: this.state.supplierreference,
    countryname: this.state.countryname,
    productcost: this.state.productcost,
    devisename: this.state.devisename,
    unitspercase: this.state.unitspercase,
    weicase: this.state.weicase,
    lencase: this.state.lencase,
    widcase: this.state.widcase,
    heicase: this.state.heicase,
    casesperpallet: this.state.casesperpallet,
    weipallet: this.state.weipallet,
    lenpallet: this.state.lenpallet,
    widpallet: this.state.widpallet,
    heipallet: this.state.heipallet,
    isactive: this.state.isactive
  })
    .then((result) => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert('Failed');
    });
}




copyClick() {

  const {
    sapcode, 
    productlabelname, 
    itemtypename, 
    applicationname, 
    migration,
    leadtime,
    satellite,
    productdescription,
    suppliername,
    supplierreference,
    countryname,
    productcost,
    devisename,
    unitspercase,
    weicase,
    lencase,
    widcase,
    heicase,
    casesperpallet,
    weipallet,
    lenpallet,
    widpallet,
    heipallet,
    isactive,
    initialSapcode,
    initialProductlabelname,
    initialItemtypename,
    initialApplicationname,
    initialMigration,
    initialProductdescription,
    initialSuppliername,
    initialSupplierreference,
    initialCountryname,
    initialProductcost,
    initialDevisename,
    initialUnitspercase,
    initialWeicase,
    initialLencase,
    initialWidcase,
    initialHeicase,
    initialCasesperpallet,
    initialWeipallet,
    initialLenpallet,
    initialWidpallet,
    initialHeipallet,
    initialIsactive,
    sapCodes,
    productDescriptions
   } = this.state;

   

  if (!sapcode) {
    alert('SAP Code is required');
    return;
  }

  if (sapCodes.some(name => name.toLowerCase() === sapcode.toLowerCase() && sapcode !== initialSapcode)) {
    alert('SAP Code already exists. Please provide a unique SAP Code.');
    return;
  }

  if (!productlabelname) {
    alert('productlabel is required');
    return;
  }

  if (!itemtypename) {
    alert('itemtype is required');
    return;
  }

  if (!applicationname) {
    alert('application is required');
    return;
  }

  if (!productdescription) {
    alert('productdescription is required');
    return;
  }

  if (productDescriptions.some(name => name.toLowerCase() === productdescription.toLowerCase() && productdescription !== initialProductdescription)) {
    alert('Product Description already exists. Please provide a unique Product Description.');
    return;
  }

  if (!productcost) {
    alert('Cost is required');
    return;
  }

  if (!devisename) {
    alert('Devise is required');
    return;
  }

  axiosService.post('/defaultproductscreate/', {
    sapcode:this.state.sapcode,
    productlabelname: this.state.productlabelname,
    itemtypename: this.state.itemtypename,
    applicationname: this.state.applicationname,
    migration: this.state.migration,
    leadtime: leadtime === "" ? null : Number(leadtime),
    satellite: satellitePayloadValue(satellite),
    productdescription: this.state.productdescription,
    suppliername: this.state.suppliername,
    supplierreference: this.state.supplierreference,
    countryname: this.state.countryname,
    productcost: this.state.productcost,
    devisename: this.state.devisename,
    unitspercase: this.state.unitspercase,
    weicase: this.state.weicase,
    lencase: this.state.lencase,
    widcase: this.state.widcase,
    heicase: this.state.heicase,
    casesperpallet: this.state.casesperpallet,
    weipallet: this.state.weipallet,
    lenpallet: this.state.lenpallet,
    widpallet: this.state.widpallet,
    heipallet: this.state.heipallet,
    isactive: this.state.isactive
  })
    .then((result) => {
      alert('Product created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch((error) => {
      alert('Failed');
    });
}


deleteClick(id) {
  
  if (this.state.uniqueProductIdsPurchases.includes(id)) {
    alert('Cannot delete this Product as it is in the Purchases Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueProductIdsKitsContentKits.includes(id)) {
    alert('Cannot delete this Product as it is in the Kits Content Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueProductIdsKitsContentProducts.includes(id)) {
    alert('Cannot delete this Product as it is in the Kits Content Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueProductIdsContainersContentProducts.includes(id)) {
    alert('Cannot delete this Product as it is in the Containers Content Table !');
    return; // Exit the function without making the delete request
  }
  

  if (this.state.uniqueProductIdsForecasts.includes(id)) {
    alert('Cannot delete this Product as it is in the Forecasts Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueProductIdsReturns.includes(id)) {
    alert('Cannot delete this Product as it is in the Returns Table !');
    return; // Exit the function without making the delete request
  }

  if (this.state.uniqueProductIdsInventories.includes(id)) {
    alert('Cannot delete this Product as it is in the Inventories Table !');
    return; // Exit the function without making the delete request
  }

  if (window.confirm('Are you sure?')) {
    axiosService.delete('/defaultproducts/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error.message);
      });
  }
}


render(){
  const {
      products,
      modalTitle,
      productid,
      sapcode,
      productlabelname,
      itemtypename,
      applicationname,
      migration,
      leadtime,
      satellite,
      productdescription,
      suppliername,
      supplierreference,
      countryname,
      productcost,
      devisename,
      unitspercase,
      weicase,
      lencase,
      widcase,
      heicase,
      casesperpallet,
      weipallet,
      lenpallet,
      widpallet,
      heipallet,
      unitsperpallet,
      palletvalue,
      isactive,
      countryid,
      productlabelNames,
      itemtypeNames,
      applicationNames,
      supplierNames,
      countryNames, 
      currencyNames,
      sapCodeExists,
      productDescriptionExists,
      loading,
      uploadMessage,
      uploadErrors,
      uploadInputKey
  }=this.state;
  

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsParameters />


<div className="d-flex justify-content-between align-items-center">
  {/* Left side: Upload */}
  <div className="d-flex align-items-center">
    <button
      type="button"
      disabled={!isSuperAdmin()}
      className="btn btn-primary m-2"
      onClick={this.uploadProducts}
      style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
    >
      Upload Products
    </button>

    <input
      type="file"
      accept=".csv"
      key={uploadInputKey}
      className="form-control m-2"
      onChange={this.handleUploadFileChange}
      style={{ width: "250px", height: "28px", fontSize: "12px" }}
    />
  </div>

  {/* Right side: Download + Add */}
  <div className="d-flex align-items-center">
    <button
      type="button"
      className="btn btn-primary m-2"
      onClick={this.downloadCSV}
      style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
    >
      Download
    </button>

    <button
      type="button"
      disabled={!isSuperAdmin()}
      className="btn btn-primary m-2"
      data-bs-toggle="modal"
      data-bs-target="#exampleModal"
      onClick={() => this.addClick()}
      style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
    >
      Add Product
    </button>
  </div>
</div>

<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>

      </div>
      ProductId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
  style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeSapcodeFilter}
      placeholder="Filter"/>
      </div>
      SAP Code
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      ProductLabel
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      ItemType
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Application
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Migration
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Leadtime(months)
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Satellite
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
  style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>
      </div>
      Product Description
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Supplier
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Supplier Reference
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Origin Country
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Product Cost
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Currency
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      UnitsPerCase
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      WeiCase
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      LenCase
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      WidCase
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      HeiCase
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      CasesPerPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      WeiPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      LenPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      WidPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      HeiPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      UnitsPerPallet
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      PalletValue
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      IsActive
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {products.map(dep=>
      <tr key={dep.productid} className="row-hover">
          <td className="table-text">{dep.productid}</td>
          <td className="table-text">{dep.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.productlabel?.productlabelname}</td>
          <td className="table-text">{dep.itemtype?.itemtypename}</td>
          <td className="table-text">{dep.application?.applicationname}</td>
          <td className="table-text">{dep.migration.toString() ?? 'N/A'}</td>
          <td className="table-text">{dep.leadtime ?? 'N/A'}</td>
          <td className="table-text">{displaySatellite(dep.satellite, { csv: true })}</td>
          <td className="table-text">{dep.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.supplier?.suppliername}</td>
          <td className="table-text">{dep.supplierreference ?? 'N/A'}</td>
          <td className="table-text">{dep.country?.countryname}</td>
          <td className="table-text">{dep.productcost ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.productcost) : 'N/A'}</td>
          <td className="table-text">{dep.currency.devisename ?? 'N/A'}</td>
          <td className="table-text">{dep.unitspercase ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.unitspercase) : 'N/A'}</td>
          <td className="table-text">{dep.weicase ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.weicase) : 'N/A'}</td>
          <td className="table-text">{dep.lencase ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.lencase) : 'N/A'}</td>
          <td className="table-text">{dep.widcase ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.widcase) : 'N/A'}</td>
          <td className="table-text">{dep.heicase ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.heicase) : 'N/A'}</td>
          <td className="table-text">{dep.casesperpallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.casesperpallet) : 'N/A'}</td>
          <td className="table-text">{dep.weipallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.weipallet) : 'N/A'}</td>
          <td className="table-text">{dep.lenpallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.lenpallet) : 'N/A'}</td>
          <td className="table-text">{dep.widpallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.widpallet) : 'N/A'}</td>
          <td className="table-text">{dep.heipallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.heipallet) : 'N/A'}</td>
          <td className="table-text">{dep.unitsperpallet ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.unitsperpallet) : 'N/A'}</td>
          <td className="table-text">{dep.palletvalue ? Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(dep.palletvalue) : 'N/A'}</td>
          <td className="table-text">{dep.isactive.toString() ?? 'N/A'}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.productid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>
          
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >SAP Code</span>
          <input
            type="text"
            className={`form-control ${sapCodeExists ? "is-invalid" : ""}`}
            value={sapcode}
            onChange={this.changeSapCode}
            onBlur={this.checkSapCodeExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }} 
          />
          {sapCodeExists && <div className="invalid-feedback">SAP code already exists.</div>}
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductLabel</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productlabel</option>
            {this.state.productlabelNames.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Item Type</span>
          <select
            className="form-select"
            value={this.state.itemtypename}
            onChange={(event) => this.setState({ itemtypename: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select itemtype</option>
            {this.state.itemtypeNames.map((itemtype) => (
              <option key={itemtype} value={itemtype}>
                {itemtype}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Application</span>
          <select
            className="form-select"
            value={this.state.applicationname}
            onChange={(event) => this.setState({ applicationname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select application</option>
            {this.state.applicationNames.map((application) => (
              <option key={application} value={application}>
                {application}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Migration</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={migration}
            onChange={this.changeMigration}
            
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Leadtime</span>
          <input
            type="number"
            className="form-control"
            value={leadtime}
            onChange={this.changeLeadtime}
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Satellite</span>
          <input
            type="text"
            className="form-control"
            value={satellite}
            onChange={this.changeSatellite}
            style={{ fontSize: "12px" }}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Product Description</span>
          <input
            type="text"
            className={`form-control ${productDescriptionExists ? "is-invalid" : ""}`}
            value={productdescription}
            onChange={this.changeProductDescription}
            onBlur={this.checkProductDescriptionExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }} 
          />
          {sapCodeExists && <div className="invalid-feedback">Product description already exists.</div>}
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Supplier</span>
          <select
            className="form-select"
            value={this.state.suppliername}
            onChange={(event) => this.setState({ suppliername: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select supplier</option>
            {this.state.supplierNames.map((supplier) => (
              <option key={supplier} value={supplier}>
                {supplier}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Supplier Reference</span>
          <input
            type="text"
            className="form-control"
            value={supplierreference}
            onChange={this.changeSupplierReference}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Origin Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Cost</span>
          <input
            type="number"
            className="form-control"
            value={productcost}
            onChange={this.changeProductCost}
            style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Devise</span>
          <select
            className="form-select"
            value={this.state.devisename}
            onChange={(event) => this.setState({ devisename: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a currency</option>
            {this.state.currencyNames.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >UnitsPerCase</span>
          <input
            type="number"
            className="form-control"
            value={unitspercase}
            onChange={this.changeUnitsPerCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WeiCase</span>
          <input
            type="number"
            className="form-control"
            value={weicase}
            onChange={this.changeWeiCase}
            style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >LenCase</span>
          <input
            type="number"
            className="form-control"
            value={lencase}
            onChange={this.changeLenCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WidCase</span>
          <input
            type="number"
            className="form-control"
            value={widcase}
            onChange={this.changeWidCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >HeiCase</span>
          <input
            type="number"
            className="form-control"
            value={heicase}
            onChange={this.changeHeiCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >CasesPerPallet</span>
          <input
            type="number"
            className="form-control"
            value={casesperpallet}
            onChange={this.changeCasesPerPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WeiPallet</span>
          <input
            type="number"
            className="form-control"
            value={weipallet}
            onChange={this.changeWeiPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >LenPallet</span>
          <input
            type="number"
            className="form-control"
            value={lenpallet}
            onChange={this.changeLenPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WidPallet</span>
          <input
            type="number"
            className="form-control"
            value={widpallet}
            onChange={this.changeWidPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >HeiPallet</span>
          <input
            type="number"
            className="form-control"
            value={heipallet}
            onChange={this.changeHeiPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >IsActive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        {productid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {productid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(productid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >SAP Code</span>
          <input
            type="text"
            className={`form-control ${sapCodeExists ? "is-invalid" : ""}`}
            value={sapcode}
            onChange={this.changeSapCode}
            onBlur={this.checkSapCodeExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }} 
          />
          {sapCodeExists && <div className="invalid-feedback">SAP code already exists.</div>}
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductLabel</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productlabel</option>
            {this.state.productlabelNames.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Item Type</span>
          <select
            className="form-select"
            value={this.state.itemtypename}
            onChange={(event) => this.setState({ itemtypename: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select itemtype</option>
            {this.state.itemtypeNames.map((itemtype) => (
              <option key={itemtype} value={itemtype}>
                {itemtype}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Application</span>
          <select
            className="form-select"
            value={this.state.applicationname}
            onChange={(event) => this.setState({ applicationname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select application</option>
            {this.state.applicationNames.map((application) => (
              <option key={application} value={application}>
                {application}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Migration</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={migration}
            onChange={this.changeMigration}
            
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Leadtime</span>
          <input
            type="number"
            className="form-control"
            value={leadtime}
            onChange={this.changeLeadtime}
            style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Satellite</span>
          <input
            type="text"
            className="form-control"
            value={satellite}
            onChange={this.changeSatellite}
            style={{ fontSize: "12px" }}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Product Description</span>
          <input
            type="text"
            className={`form-control ${productDescriptionExists ? "is-invalid" : ""}`}
            value={productdescription}
            onChange={this.changeProductDescription}
            onBlur={this.checkProductDescriptionExists} // Check SAP code existence on blur (when user moves out of the field)
            style={{ fontSize: "12px" }} 
          />
          {sapCodeExists && <div className="invalid-feedback">Product description already exists.</div>}
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Supplier</span>
          <select
            className="form-select"
            value={this.state.suppliername}
            onChange={(event) => this.setState({ suppliername: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select supplier</option>
            {this.state.supplierNames.map((supplier) => (
              <option key={supplier} value={supplier}>
                {supplier}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Supplier Reference</span>
          <input
            type="text"
            className="form-control"
            value={supplierreference}
            onChange={this.changeSupplierReference}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Origin Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Cost</span>
          <input
            type="number"
            className="form-control"
            value={productcost}
            onChange={this.changeProductCost}
            style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Devise</span>
          <select
            className="form-select"
            value={this.state.devisename}
            onChange={(event) => this.setState({ devisename: event.target.value })}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select a currency</option>
            {this.state.currencyNames.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >UnitsPerCase</span>
          <input
            type="number"
            className="form-control"
            value={unitspercase}
            onChange={this.changeUnitsPerCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WeiCase</span>
          <input
            type="number"
            className="form-control"
            value={weicase}
            onChange={this.changeWeiCase}
            style={{ fontSize: "12px" }} 
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >LenCase</span>
          <input
            type="number"
            className="form-control"
            value={lencase}
            onChange={this.changeLenCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WidCase</span>
          <input
            type="number"
            className="form-control"
            value={widcase}
            onChange={this.changeWidCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >HeiCase</span>
          <input
            type="number"
            className="form-control"
            value={heicase}
            onChange={this.changeHeiCase}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >CasesPerPallet</span>
          <input
            type="number"
            className="form-control"
            value={casesperpallet}
            onChange={this.changeCasesPerPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WeiPallet</span>
          <input
            type="number"
            className="form-control"
            value={weipallet}
            onChange={this.changeWeiPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >LenPallet</span>
          <input
            type="number"
            className="form-control"
            value={lenpallet}
            onChange={this.changeLenPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >WidPallet</span>
          <input
            type="number"
            className="form-control"
            value={widpallet}
            onChange={this.changeWidPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >HeiPallet</span>
          <input
            type="number"
            className="form-control"
            value={heipallet}
            onChange={this.changeHeiPallet}
            style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >IsActive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>

        {productid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {productid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
}

